import React from "react";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { paths } from "@utils/navigation";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const startsWithPath = (pathname: string, prefix: string) =>
  pathname === prefix || pathname.startsWith(`${prefix}/`);

const LicensesPage: React.FC = () => {
  const { user, token } = useAuthStore();
  const { pathname, search } = useLocation();

  const isManagingDirectorOffice = user?.roles?.includes("managing-director-office");
  const licensesPrefix = `/${paths.licenses.index}`;
  const accountsPrefix = `/${paths.licenses.accountIndex}`; // "/accounts"
  const portOperatorPrefix = `/${paths.licenses.portOperatorIndex}`;
  const isResolvingUserContext = Boolean(token) && !user;

  const isServiceDesk = user?.roles?.includes("service-desk");
  const isVendorMaster = user?.roles?.includes("vendor-master");
  if (isResolvingUserContext) {
    return null;
  }

  if (startsWithPath(pathname, licensesPrefix)) {
    const suffix = pathname.slice(licensesPrefix.length);

    if (isManagingDirectorOffice) {
      return <Navigate to={`${portOperatorPrefix}${suffix}${search}`} replace />;
    }

    if (isServiceDesk) {
      return <Navigate to={`${accountsPrefix}${suffix}${search}`} replace />;
    }

    if (isVendorMaster) {
      return (
        <div data-testid="licenses">
          <Outlet />
        </div>
      );
    }
  }

  if (isServiceDesk && startsWithPath(pathname, portOperatorPrefix)) {
    const suffix = pathname.slice(portOperatorPrefix.length);
    return <Navigate to={`${accountsPrefix}${suffix}${search}`} replace />;
  }

  if (isManagingDirectorOffice && startsWithPath(pathname, accountsPrefix)) {
    const suffix = pathname.slice(accountsPrefix.length);
    return <Navigate to={`${portOperatorPrefix}${suffix}${search}`} replace />;
  }

  return (
    <div data-testid="licenses">
      <Outlet />
    </div>
  );
};

export default LicensesPage;
